import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { TaxonomyTargetAudience } from '../../../../types/uncinc_profile/taxonomy';
import TaxonomyTargetAudiencePageChild from './Child';
import TaxonomyTargetAudiencePageParent from './Parent';

export interface TargetAudienceProps {
  entity: ImmutableEntity<TaxonomyTargetAudience>;
}

const TaxonomyTargetAudiencePage: React.FC<TargetAudienceProps> = ({ entity }) => {
  const targetAudience = entity.toJS();
  const parent = targetAudience.parent[0]?.target_id;

  // If the taxonomy has a parent, it must be a child.
  if (parent) {
    return <TaxonomyTargetAudiencePageChild entity={entity} />;
  }

  // If the taxonomy has no parent, itself must be a parent.
  return <TaxonomyTargetAudiencePageParent entity={entity} />;
};

export default TaxonomyTargetAudiencePage;
